import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import page from '../views/page.vue'
import courses from '../views/courses.vue'
import techanalysis from '../views/techanalysis.vue'
import webinar from '../views/webinar.vue'
import profile from '../views/profile.vue'
import NotFound from '../views/NotFound.vue';
import analysis from '../views/analysis.vue';
import GateToPay from '../views/GateToPay.vue';
import Calculations from '../views/Calculations.vue';
import Calculations2 from '../views/Calculations2.vue';


//import articles from '../views/articles.vue';
import referafriend from '../views/referafriend.vue';
import promotions from '../views/promotions.vue';


Vue.use(VueRouter)

  const routes = [
  {
    path: '/:lang/',
    name: 'Home',
      meta: {
          title: 'Home Page - Example App',
      },
    component: Home
  },
      {
    path: '/page',
    name: 'Page',
      meta: {
          title: ' Page - Example App',
      },

  },


      {
          path: '/:lang/webinar',
          name: 'Webinar',
          meta: {
              title: ' Page - Example App',
          },
          component: webinar
      },

      {
          path: '/:lang/promotions',
          name: 'Promotions',
          meta: {
              title: ' Page - Example App',
          },
          component: promotions
      },

       {
          path: '/:lang/Technical%20Analysis',
          name: 'Analysis',
          meta: {
              title: ' Page - Example App',
          },
          component: analysis
      },
      {
          path: '/:lang/Technical Analysis',
          name: 'Analysis',
          meta: {
              title: ' Page - Example App',
          },
          component: analysis
      },
      {
          path: '/:lang/Refer%20A%20Friend',
          name: 'referafriend',
          meta: {
              title: 'Refer a Friend',
          },
          component: referafriend

      },
 {
          path: '/:lang/Calculations',
          name: 'Calculations',
          meta: {
              title: ' Page - Example App',
          },
          component: Calculations
      },

      {
          path: '/:lang/Calculations2',
          name: 'Calculations2',
          meta: {
              title: ' Page - Example App',
          },
          component: Calculations2
      },

      {
          path: '/:lang/MarketEquityMasterCard',
          name: 'GateToPay',
          meta: {
              title: 'MarketEquityMasterCard',
          },
          component: GateToPay

      },
    //  {
        //  path: '/:lang/Articles',
         // name: 'articles',
        //  meta: {
         //     title: ' Page - Example App',
        //  },
         // component: articles
   //   },



      {
          path: '/:lang/profile',
          name: 'Profile',
          meta: {
              title: ' Page - Example App',
          },
          component: profile
      },
      {

          path: '/:lang/webinar/profile/:profileid',
          name: 'profile',
          meta: {
              title: ' profile',
          },
          component: profile
      },
      {
          path: '/:lang/:name',
          name: 'about',
          meta: {
              title: ' about',
          },
          component: page
  },
      {
          path: '/courses',
          name: 'Courses',
          meta: {
              title: ' Page - Example App',
          },

      },
      {

          path: '/:lang/:name/:courseid',
          name: 'courses',
          meta: {
              title: ' courses',
          },
          component: courses
      },


      // {
      //     path: '/techanalysis',
      //     name: 'Techanalysis',
      //     meta: {
      //         title: ' Page - Example App',
      //     },
      //
      // },

{
          path: '/:lang/TechnicalAnalysis',
          name: 'analysis',
          meta: {
              title: ' Page - Example App',
          },
          component: analysis
      },


      {

          path: '/:lang/:tech/:currency/:name/:analysisid',
          name: 'Techanalysis',
          meta: {
              title: ' Techanalysis',
          },
          component: techanalysis
      },

      {
          path: '/:lang/:*',
          name: 'NotFound',
          component: NotFound
      },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
